import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import { useGetMiniMenuReportsInfiniteQuery } from '@/store/slices/api/transmissionReport/transmissionReportsApiSlice';

import { ReportColor } from '@/types/transmissionReport';

export const REPORT_LIMIT_MINI_MENU = 50;

export const useMiniMenuReportsInfinite = ({
  color,
  sort,
  onMountFetch = false
}: {
  color: ReportColor;
  sort?: { column: string; order: 'ASC' | 'DESC' };
  onMountFetch?: boolean;
}) => {
  const { filters } = useAppSelector((state) => state.preferences);
  const { signatureStatus } = useAppSelector((state) => state.auth);
  const { search } = useAppSelector((state) => state.transmissionReports);

  const filterValues = useMemo(
    () => ({
      clinicIds: filters?.clinics.map((c) => c.value) ?? [],
      practitionerIds: filters?.practitioners.map((p) => p.value) ?? [],
      signingPractitionerIds:
        filters?.signingPractitioners?.map((signingPractitioner) => signingPractitioner.value) ??
        [],
      deviceTypes: filters?.deviceTypes.map((d) => d.value) ?? [],
      signatureStatus,
      color,
      search: search ?? '',
      limit: REPORT_LIMIT_MINI_MENU,
      vendors: filters?.vendors.map((vendor) => vendor.value) ?? [],
      ...(sort ? { sort } : {})
    }),
    [filters, color, search, signatureStatus, sort]
  );

  // Skip the query if color is ReviewPending (handled by separate endpoint)
  const shouldSkip = color === ReportColor.ReviewPending;

  return useGetMiniMenuReportsInfiniteQuery(filterValues, {
    refetchOnMountOrArgChange: onMountFetch,
    skip: shouldSkip
  });
};
